import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Text } from '../../../components/Text/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const WellHelpText = props => {
  const {
      children
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Text, Object.assign({
    as: "div",
    typography: "body-100"
  }, restProps, {
    children: children
  }));
};